import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { GatingContext, WidgetsContext } from '../widgets/core/context';
import Content from '../widgets/core/content';

import { getContentForFieldSelector } from './fields';
import { DefaultViewerModal } from './Modals/DefaultViewerModal';
import { LightBoxViewerModal } from './Modals/LightBoxViewerModal';

import styles from './assetviewer.module.scss';


export function AssetViewer({ show, initialContent, redirect, asset, contentGrid, onActiveAssetChange, onClose }) {
  const scrollContainerRef = React.useRef(null);
  const scrollPosition = React.useRef(0);
  const touchPosition = React.useRef(0);

  const context = React.useContext(WidgetsContext);
  const contentContext = React.useContext(Content.Context);

  const [activeAsset, setActiveAsset] = React.useState();
  const [fullscreen, setFullscreen] = React.useState(false);

  const widgetContext = React.useContext(WidgetsContext);
  const gatingContext = React.useContext(GatingContext);

  const isPreview = widgetContext?.preview;

  const [state, setState] = useState({
    position: 0,
    visible: true,
    fixed: false,
    scrollDisabled: false,
    selected: {},
    preloadedAssets: []
  });

  const [assetMappings, setAssetMappings] = useState([]);

  const [snapAsset, setSnapAsset] = useState(null);
  const [showRecommendSlide, setShowRecommendSlide] = useState(false);
  const [journeyPaused, setJourneyPaused] = useState({
    paused: false,
    assetId: null,
  });
  const [nextJourneyAsset, setNextJourneyAsset] = useState({
    step: null,
    journeyExecution: null,
  });
  const [journeyTriggered, setJourneyTrigger] = useState(false);
  const [hasConditionRun, setHasConditionRun] = useState(false);
  const [isJourneyEnd, setIsJourneyEnd] = useState(false);
  const [journeyConfig, setJourneyConfig] = useState({
    asset: null,
    journey: null
  });
  
  const assetViewerType = _.get(initialContent, 'viewer') || 'BINGE';
  const contentPage = useSelector(state => {
    var mappings = [];

    if (initialContent) {
      mappings = [initialContent];
    }

    if (!contentGrid) {
      return {
        items: mappings,
        loading: false,
        currentPage: 0,
        totalPages: 0,
        itemsPerPage: 0
      };
    }

    const widgets = _.get(state, `${context.selector}.widgets`) || [];
    const contentGridWidget = widgets.find(item => item.uid === contentGrid);

    const items = _.get(contentGridWidget, 'content.mappings.items') || [];
    mappings = [...mappings, ...items];
    mappings = _.uniqBy(mappings, 'uid');

    const loading = _.get(contentGridWidget, 'content.mappings.loading', false);
    const currentPage = _.get(contentGridWidget, 'content.mappings.pagination.current', 0);
    const totalPages = _.get(contentGridWidget, 'content.mappings.pagination.totalPages', 1);
    const itemsPerPage = _.get(contentGridWidget, 'properties.desktop.layoutStyle.itemsPerPage', 2);
    const pagination = _.get(contentGridWidget, 'properties.desktop.layoutStyle.pagination', 'infinite_scroll');

    return {
      items: mappings,
      loading: loading,
      currentPage: currentPage,
      totalPages: totalPages,
      itemsPerPage: itemsPerPage,
      pagination: pagination
    };
  });
  const isJourneyAsset = ((assetMappings || []).length) != (_.get(contentPage, "items", []).length < 2);
  const alias = useSelector(state => _.get(state, `pages.item.canonical`));
  const page = contentContext?.page || alias;
  const pageSession = useSelector((state) =>
    _.get(state, `pages.analytics[${page}].id`, null)
  )
  const [pageSessionState, setPageSessionState] = useState(pageSession);
  const name = getContentForFieldSelector(nextJourneyAsset?.step?.asset, 'name') || "";
  const icon = getContentForFieldSelector(nextJourneyAsset?.step?.asset, 'icon');
  const iconUrl = _.get(icon, 'url') || '/public/cleverstory/v2/static/default_card.jpg';

  const handleWheelEvent = _.throttle((wheelEvent) => {
    const scrollContainer = scrollContainerRef.current.dialog.querySelector(`.${styles.assetViewerContent}`);

    const previousPosition = scrollPosition.current;
    const currentPosition = scrollContainer.scrollTop;

    if (wheelEvent.deltaX) {
      scrollPosition.current = scrollContainer.scrollTop;
      return;
    }

    if (previousPosition > currentPosition) {
      scrollContainer.classList.add(styles.headerVisible);
    } else {
      scrollContainer.classList.remove(styles.headerVisible);
    }

    scrollPosition.current = scrollContainer.scrollTop;
  }, 100);

  const handleTouchStart = (e) => {
    touchPosition.current = e.touches[0].clientY;
  }

  const handleTouchEnd = (e) => {
    const scrollContainer = scrollContainerRef.current.dialog.querySelector(`.${styles.assetViewerContent}`);
    var currentPosition = e.changedTouches[0].clientY;
    const previousPosition = touchPosition.current;

    const diff = currentPosition - previousPosition;

    if (diff > 0) {
      scrollContainer.classList.add(styles.headerVisible);
    } else {
      scrollContainer.classList.remove(styles.headerVisible);
    }
  }

  useEffect(()=> {
    if(pageSession) {
      setPageSessionState(pageSession);
    }
  },[pageSession]);

  useEffect(()=>{
    const newItems = contentPage.items.filter(item => !assetMappings.includes(item));

    if (newItems.length > 0) {
      setAssetMappings((prevMappings) => {
        return [...prevMappings, ...newItems];
      });
    }

  },[contentPage.items])

  useEffect(() => {
    if(widgetContext.onTriggerMixpanelEvent){
      widgetContext.onTriggerMixpanelEvent(widgetContext.session, 'Page Viewed', {
        screen_name: 'Asset Viewer'
      })
    }
  }, [])

  useEffect(() => {
    if (show) {
      setState(state => {
        return {
          ...state,
          selected: asset
        }
      })

      var scrollContent = document.getElementsByClassName('modal-content');

      scrollContent = _.head(scrollContent);
      scrollContent.addEventListener('wheel', handleWheelEvent);
      scrollContent.addEventListener('touchstart', handleTouchStart);
      scrollContent.addEventListener('touchend', handleTouchEnd);

      return (() => {
        scrollContent.removeEventListener('wheel', handleWheelEvent);
        scrollContent.removeEventListener('touchstart', handleTouchStart);
        scrollContent.removeEventListener('touchend', handleTouchEnd);
      })
    }

  }, [show, asset]);

  useEffect(() => {
    if (!activeAsset) return;

    if (activeAsset.uid != snapAsset?.uid && nextJourneyAsset?.step != null && !isJourneyEnd && !isPreview) {

      setShowRecommendSlide(false);
      setHasConditionRun(false);

      const stepId = nextJourneyAsset.step.id;
      const journeyExecutionId = nextJourneyAsset.journeyExecution.id;

      contentContext.fetchAssetJourney(asset, stepId, journeyExecutionId, pageSessionState);
    }

    if (nextJourneyAsset?.step?.asset != null) {
      const selectedAssetUid = snapAsset?.uid;
      const pausedAssetUid = journeyPaused?.assetId;

      if (selectedAssetUid == pausedAssetUid) {
        setJourneyPaused({ paused: false, assetId: null });
        contentContext.updateAssetJourneyExecution(snapAsset, false);
      }
    }

    contentContext.onContentChange(contentGrid, activeAsset, contentPage, redirect);

  }, [activeAsset]);

  const fetchAdditionalContent = () => {
    const nextPage = contentPage.currentPage + 1;
    if (nextPage >= contentPage.totalPages || contentPage.pagination === 'none') {
      return;
    }

    contentContext.fetchMappingsForContentGrid(contentGrid, nextPage, contentPage.itemsPerPage);
  }

  const handleAssetSelection = (content) => {

    if (nextJourneyAsset?.step?.asset != null && !isJourneyEnd) {
      const selectedAssetUid = content.uid;
      const nextAssetUid = nextJourneyAsset.step.asset.uid;

      if (selectedAssetUid != nextAssetUid) {
        setJourneyPaused({ paused: true, assetId: snapAsset?.uid });
        contentContext.updateAssetJourneyExecution(snapAsset, true);

        setTimeout(() => {
          setNextJourneyAsset({
            step: null,
            journeyExecution: null,
          });
        }, 300);
      }

      if (selectedAssetUid == nextAssetUid && !isPreview) {

        const stepId = nextJourneyAsset.step.id;
        const journeyExecutionId = nextJourneyAsset.journeyExecution.id;

        contentContext.fetchAssetJourney(content, stepId, journeyExecutionId, pageSessionState);
      }
    }

    setShowRecommendSlide(false);


    setState(state => {
      return {
        ...state,
        selected: content
      }
    });

    const newTab = content.content.newTab;

    switch (content.type) {
      case 'INTERACTIVE_CONTENT':
      case 'LANDING_PAGE':
      case 'RESOURCE_CENTER': {
        if (!content.url) {
          return;
        }

        const pageUrl = `${content.content.domain}${content.url}`;

        if (newTab) {
          window.open(pageUrl);
        } else {
          window.location.href = pageUrl;
        }
        break;
      }
      case 'ASSET': {
        scrollToAsset(content.uid);
        break;
      }
    }
  }


  const scrollToAsset = (id) => {
    const scrollContainer = scrollContainerRef.current.dialog.querySelector(`.${styles.assetViewerContent}`);
    const assetContainer = scrollContainer.querySelector(`[data-asset='${id}']`);

    if (!assetContainer) {
      return;
    }

    const scrollTop = scrollContainer.scrollTop;
    const assetOffset = assetContainer.offsetTop;

    const scrollDown = assetOffset > scrollTop;
    const offset = scrollDown ? 7 : 7;

    scrollContainer.scrollTo({
      top: assetContainer.offsetTop + offset,
      behavior: "smooth"
    });
  }

  const handleAssetVisibilityChange = (asset, visible, analytics) => {
    const prevId = _.get(activeAsset, 'asset.id');
    const nextId = _.get(asset, 'id');


    if (prevId == nextId && !visible) {
      setActiveAsset(null);
      return;
    }

    if (visible) {
      setActiveAsset(asset);
    }
  }

  const handleJourneyPath = (nextAsset) => {
    setAssetMappings((prevAssets) => {
      const assetIndex = prevAssets.findIndex((a) => a.uid === activeAsset?.uid);

      if (assetIndex >= 0) {
        const newAssets = [...prevAssets];

        if (snapAsset?.uid === activeAsset?.uid) {
          newAssets.splice(assetIndex + 1, 1, nextAsset);
        }
        else {
          newAssets.splice(assetIndex + 1, 0, nextAsset);
        }

        setSnapAsset(activeAsset);

        return newAssets;
      }

      return prevAssets;
    });
  };


  const handleAssetLoaded = (asset, journeyConfigurations) => {

    setState((state) => {
      const assets = (assetMappings.items || []).filter(item => item.type === 'ASSET').map(item => item.uid);
      const activeIndex = assets.indexOf(asset);
      const nextIndex = activeIndex + 1;
      const nextAsset = assets[nextIndex];

      var preloadedAssets = _.get(state, 'preloadedAssets') || [];
      preloadedAssets = [...preloadedAssets, asset];

      if (nextAsset) {
        preloadedAssets = [...preloadedAssets, nextAsset];
      }

      preloadedAssets = _.uniq(preloadedAssets);

      return {
        ...state,
        preloadedAssets: preloadedAssets
      }
    })

    if (asset?.uid != snapAsset?.uid) {
      setHasConditionRun(false);
    }

    if (nextJourneyAsset?.step != null && !isJourneyEnd && !journeyConfigurations && !isPreview) {
      const stepId = nextJourneyAsset.step.id;
      const journeyExecutionId = nextJourneyAsset.journeyExecution.id;

      contentContext.fetchAssetJourney(asset, stepId, journeyExecutionId, pageSessionState);
    }
  };

  const toggleFullScreen = () => {
    setFullscreen(state => {
      return !state
    });
  }

  const handleClose = () => {
    if (!onClose) return;

    setShowRecommendSlide(false);
    setNextJourneyAsset({
      step: null,
      journeyExecution: null,
    });
    setHasConditionRun(false);
    setAssetMappings([]);
    setJourneyTrigger(false);
    setIsJourneyEnd(false);
    setJourneyConfig({
      asset: null,
      journey: null
    })

    onClose();
  };

  return assetViewerType === "BINGE" ? (
    <DefaultViewerModal
      scrollContainerRef={scrollContainerRef}
      fullscreen={fullscreen}
      show={show}
      handleClose={handleClose}
      showRecommendSlide={showRecommendSlide}
      nextJourneyAsset={nextJourneyAsset}
      handleAssetSelection={handleAssetSelection}
      iconUrl={iconUrl}
      name={name}
      isJourneyAsset={isJourneyAsset}
      contentPage={contentPage}
      fetchAdditionalContent={fetchAdditionalContent}
      activeAsset={activeAsset}
      assetMappings={assetMappings}
      gatingContext={gatingContext}
      state={state}
      handleJourneyPath={handleJourneyPath}
      setNextJourneyAsset={setNextJourneyAsset}
      journeyTriggered={journeyTriggered}
      setJourneyTrigger={setJourneyTrigger}
      journeyPaused={journeyPaused}
      setShowRecommendSlide={setShowRecommendSlide}
      hasConditionRun={hasConditionRun}
      setHasConditionRun={setHasConditionRun}
      isJourneyEnd={isJourneyEnd}
      setIsJourneyEnd={setIsJourneyEnd}
      isPreview={isPreview}
      pageSessionState={pageSessionState}
      setPageSessionState={setPageSessionState}
      journeyConfig={journeyConfig}
      setJourneyConfig={setJourneyConfig}
      handleAssetLoaded={handleAssetLoaded}
      handleAssetVisibilityChange={handleAssetVisibilityChange}
      toggleFullScreen={toggleFullScreen}
    />
  ) : (
    <LightBoxViewerModal
      scrollContainerRef={scrollContainerRef}
      fullscreen={true}
      show={show}
      handleClose={handleClose}
      activeAsset={activeAsset}
      initialContent={initialContent}
      gatingContext={gatingContext}
      state={state}
      isPreview={isPreview}
      handleAssetLoaded={handleAssetLoaded}
      handleAssetVisibilityChange={handleAssetVisibilityChange}
    />
  );
}

